/**
 * SettingsUIConstants
 *
 * Centralized style definitions for consistent settings UI appearance.
 */

export const settingsUI = {
  /** Label style for setting titles */
  label: 'text-sm font-medium',

  /** Description style for setting subtitles */
  description: 'text-sm text-muted-foreground',

  /** Smaller description for compact contexts (e.g., menu options) */
  descriptionSmall: 'text-xs text-muted-foreground',

  /** Gap between label and description (applied to description as margin-top) */
  labelDescriptionGap: 'mt-0',

  /** Gap for label group containers (applied as space-y) */
  labelGroup: 'space-y-0',
}
